jQuery(document).ready(function($) {
    $('#boletins-count').on('click', function() {
        const total = parseInt($(this).data('count'), 10) || 0;
        const offset = $('.boletim-card').length;

        if (offset >= total) {
            $(this).hide();
            return;
        }

        const searchText = $(this).data('text');

        $.ajax({
            url: phpVars.ajaxUrl,
            method: 'POST',
            data: {
                action: 'get_post_search_limited',
                text: searchText,
                offset: offset
            },
            beforeSend: function() {
                $('#boletins-count').prop('disabled', true);
            },
            success: function(response) {
                if (response.success && response.data.length) {
                    response.data.forEach(function(item) {
                        const cardHtml = `
                            <div class="page-support__card boletim-card">
                                <a href="${item.permalink}">
                                    <div class="page-support__card-image" style="background-image:url('');"></div>
                                </a>
                                <div class="page-support__card-content">
                                    <a href="${item.permalink}">
                                        <h3>Boletim nº ${item.title}</h3>
                                    </a>
                                    <p>${item.emphasis}</p>
                                    <div class="page-support__card-actions">
                                        <a href="${item.permalink}">Acesse</a>
                                    </div>
                                </div>
                            </div>
                        `;
                        $('.page-support__main--boletim').append(cardHtml);
                    });

                    const newCount = $('.boletim-card').length;
                    if (newCount >= total) {
                        $('#boletins-count').hide();
                    } else {
                        $('#boletins-count').prop('disabled', false);
                    }
                } else {
                    $('#boletins-count').hide();
                }
            },
            error: function() {
                console.error('Erro ao buscar boletins.');
                $('#boletins-count').prop('disabled', false);
            }
        });
    });
});